const adminRoutes = {
    sign_in: "/sign-in",
    sign_out: "/sign-out",
    refresh_token: "/refresh-token",
    users: "/users",
    providers: "/providers",
    services: "/services",
    reports: "/reports",
    block: "/block",
    status: "/status",
    unblock: "/unblock",
    approvals: "/approvals",
    bookings: "bookings",
    sales: "/sales",
    dashboard: "/dashboard",
    revenue: "/revenue",
};
export default adminRoutes;
